import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import { useStyleStore } from "@bloglovin/vue-component-library";
import useDynamicComponentStore from "%/stores/dynamic-component-store";

export default class TextShadow extends BaseOption {
  static userInterfaceComponent = {
    label: "Text Shadow",
    component: inspectorTools.SHADOW_PICKER,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useDefaultVariableLinking: false,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      multiple: false,
      title: "Text Shadow",
      schema: {
        fields: {
          color: true,
          blur: true,
          offsetX: true,
          offsetY: true,
          spread: false,
          inset: false,
        },
        defaultShadow() {
          return {
            color: { value: "standard", source: "theme.border" },
            blur: 2,
            offsetX: 2,
            offsetY: 2,
          };
        },
      },
    },
  };

  static defaultValue = [];

  static convertConfigValueToCompiledValue(configValue, themeId) {
    let textShadowStrings = [];

    if (!configValue) {
      return "";
    }

    if (!Array.isArray(configValue)) {
      configValue = [configValue];
    }

    if (themeId === undefined || themeId === null) {
      themeId = useDynamicComponentStore().themeId;
    }

    configValue.forEach(shadow => {
      let textShadowString = "";

      if (shadow.inset) {
        textShadowString += "inset";
      }

      ["offsetX", "offsetY", "blur"].forEach(prop => {
        const formatted = this.formatShadowValue(shadow[prop]);
        textShadowString += ` ${formatted}px`;
      });

      if (shadow.color !== null) {
        textShadowString += ` ${TextShadow.getTextShadowColor(shadow.color, themeId)}`;
      }

      textShadowStrings.push(textShadowString);
    });

    return textShadowStrings[0] || "none";
  }

  static getTextShadowColor(option, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];
    if (option.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(option, styleStore.themes[themeId], palette, themeId, themeMode);
  }
}
